module.exports = "<app-loading-header></app-loading-header>\n<app-loading-filters></app-loading-filters>\n<app-loading-results></app-loading-results>"